import { Component, OnInit } from '@angular/core';
import { Utils } from 'src/app/tools/utils';
import { HeaderService } from 'src/app/tools/header.service';

@Component({
    selector: 'app-adminhome',
    templateUrl: './adminhome.component.html',
    styleUrls: ['./adminhome.component.scss']
})
export class AdminhomeComponent implements OnInit {

    Utils = Utils;
    constructor(private headerService: HeaderService) { }

    ngOnInit() {
        // Pour afficher la flèche de retour
        this.headerService.changeCanBack(true);
    }

}
